<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <button class="btn btn-sm btn-link" @click="$router.go(-1)">
                <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
              </button>
              <h4 class="card-title">{{ $t("message.admin.ca-history") }}</h4>
            </div>
            <div class="container">
              <div class="card-body px-3">
                <!--<div v-for="(item, i) in search.name_details" class="row">-->
                <!-- <router-link :to="{name: 'admin-index'}" class="btn btn-sm btn-outline-primary mr-5" >{{$t('message.back')}}</router-link> -->
                <!-- <br> -->
                <!-- <br> -->
                <div class="row">
                  <div class="col-md-4">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <datepicker
                        value-type="YYYY-MM-DD"
                        format="DD.MM.YYYY"
                        @focus="filter.date_from = ' '"
                        @blur="
                          filter.date_from == ' '
                            ? (filter.date_from = '')
                            : (filter.date_from = filter.date_from)
                        "
                        inputClass="form-control"
                        :disabled="is_field_readonly"
                        v-model="filter.date_from"
                        :placeholder="$t('message.admin.ca_history_date_from')"
                        :inputAttr="{ id: 'date_from' }"
                      />
                      <label
                        for="date_from"
                        class="form-label-group-label shorter"
                        :class="
                          filter.date_from != '' && filter.date_from != null
                            ? 'topped'
                            : ''
                        "
                        >{{ $t("message.admin.ca_history_date_from") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-4">
                    <span
                      :class="['bmd-form-group mb-2 d-block form-label-group']"
                    >
                      <datepicker
                        value-type="YYYY-MM-DD"
                        format="DD.MM.YYYY"
                        @focus="filter.date_to = ' '"
                        @blur="
                          filter.date_to == ' '
                            ? (filter.date_to = '')
                            : (filter.date_to = filter.date_to)
                        "
                        inputClass="form-control"
                        :disabled="is_field_readonly"
                        v-model="filter.date_to"
                        :placeholder="$t('message.admin.ca_history_date_to')"
                        :inputAttr="{ id: 'date_to' }"
                      />
                      <label
                        for="date_to"
                        class="form-label-group-label shorter"
                        :class="
                          filter.date_to != '' && filter.date_to != null
                            ? 'topped'
                            : ''
                        "
                        >{{ $t("message.admin.ca_history_date_to") }}</label
                      >
                    </span>
                  </div>
                  <div class="col-md-4">
                    <v-select-enhanced
                      type="company"
                      v-model="filter.organisation"
                      :placeholder="$t('message.admin.ca_history_organisation')"
                    />
                  </div>
                </div>
                <div>
                  <br />
                  <button
                    :class="['btn', 'btn-success', 'btn-round', 'btn-sm']"
                    @click="filterCAHistory()"
                    id="init_search"
                  >
                    <div
                      class="loading loading-button"
                      v-if="search_loading"
                      style="margin-top: -2px; left: 16px"
                    ></div>
                    {{ $t("message.contracts.search") }}
                  </button>
                </div>

                <br />

                <b-table
                  :items="history"
                  :fields="history_fields"
                  :per-page="per_page"
                  :current-page="current_page"
                >
                  <template v-slot:cell(search_date)="data">
                    {{ momentum(data.value) }}
                  </template>

                  <template v-slot:cell(response_data)="data">
                    <button
                      class="btn btn-link w-100 d-block"
                      @click.prevent="generatePdf(data.value)"
                    >
                      {{ $t("message.admin.download") }}
                    </button>
                  </template>
                </b-table>
                <div class="d-flex justify-content-center">
                  <b-pagination
                    v-model="current_page"
                    :total-rows="history_length"
                    :per-page="per_page"
                    aria-controls="my-history-table"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-none">
      <pdf
        :user_id="0"
        :document="current_search"
        :goods="[]"
        :doc_id="0"
        source="aml"
        :doc_additional="filters"
      ></pdf>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "admin-ca-history",
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.load();
  },
  computed: {
    history_length() {
      return this.total_list_items_in_db;
    },
    locale() {
      return this.$i18n.locale;
    },
  },
  data() {
    return {
      current_page: 0,
      per_page: 20,
      history: [],
      total_list_items_in_db: 0,
      search_loading: false,
      filter: {
        organisation: { value: "", display_text: "" },
        date_from: "",
        date_to: "",
      },
      filters: {},
      current_search: {},
      is_field_readonly: false,
      history_fields: [
        {
          key: "search_query",
          label: this.$t("message.admin.search_query"),
        },
        {
          key: "search_date",
          label: this.$t("message.admin.search_date"),
        },
        {
          key: "response_data",
          label: this.$t("message.admin.history_pdf"),
        },
      ],
    };
  },
  watch: {
    current_page() {
      if (this.current_page > 0) {
        this.filterCAHistory();
      }
    }
  },
  methods: {
    momentum(date) {
      return moment(date).format("DD.MM.Y");
    },
    /**
     * Fetches list of all offers
     */
    load() {
      // this.filterCAHistory();
    },
    filterCAHistory() {
      this.history = [];
      axios
        .get(
          window.base +
            "/admin/GetCABilling?date_from=" +
            this.filter.date_from +
            "&date_to=" +
            this.filter.date_to +
            "&org_code=" +
            this.filter.organisation.value +
            "&page=" + this.current_page + 
            "&per_page=" + this.per_page,
        )
        .then((response) => {
          if (this.current_page - 1 > 0) {
            this.history = new Array((this.current_page - 1) * this.per_page).fill({});
          }
          this.history = this.history.concat(response.data.billing_response_list); //.filter(i=>i.active==1)
          this.total_list_items_in_db = response.data.total_items_in_db;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    },
    generatePdf(search) {
      this.current_search = JSON.parse(search);
      this.filters = this.current_search.content.data.filters;
      if (typeof this.current_search.content.data.search_term !== "undefined") {
        this.filters.search_term = this.current_search.content.data.search_term;
      }
      this.filters.created_at = this.current_search.content.data.created_at;
      this.filters.updated_at = this.current_search.content.data.updated_at;
      setTimeout(() => {
        this.$root.$emit("print-aml", this.current_search);
      }, 2000);
    },
  },
};
</script>
<style>
.page-item.active button {
  /* background: #9c27b0 !important; */
  /* color: #fff !important; */
}
</style>
